export default "__VITE_ASSET__2c3ca41d__"